module.exports = __webpack_public_path__ + "static/media/rahat.1601cc40.jpeg";